<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Mechanical Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Mechanical Engineering'}]"/>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex justify-center">
            <div class="flex flex-col space-y-1 items-center">
              <img class="shadow-lg" :src="`/static/images/mechanical/faculty/Gujarathi_TV.jpg`"
                   alt="Head of Department of Mechanical Engineering">
              <h3 class="text-lg font-bold text-gray-800 leading-tight">Prof. T. V. Gujrathi</h3>
              <h4 class="text-gray-600 leading-tight">Head of the Department</h4>
            </div>
          </div>
          <blockquote class="mt-3 text-gray-600 text-justify font-medium">
            <p>Welcome to the Department of Mechanical Engineering at SND College of Engineering and Research Center,
              Yeola. We started our journey in the year of 2006 with mechanical stream.</p>
            <p>We have a strong undergraduate and postgraduate program in mechanical engineering. At the postgraduate
              level, we offer M. E. (Design). The sanctioned students’ strengths of B.E. and M. E. (Design) are
              respectively 180 and 18 per year.</p>
            <p>Our department features state-of-the-art infrastructure including well-developed laboratories for core
              courses like Fluid Mechanics & Machinery, Industrial Fluid Power, Thermal Engineering, Power Engineering,
              Refrigeration and Air-conditioning, etc. It also features a full-fledged workshop which can hone to
              students’ knowledge and hands-on skills related to manufacturing. Students can learn modern software
              related to drafting, modelling and analysis, which are nowadays a pre-requisite in industry through our
              CAD laboratory. </p>
            <p>We have excellent faculty with a blend of academics and industry. Almost everyone has completed their
              post-graduation. They continuously update themselves to the latest trends by attending faculty development
              programmes, industrial trainings and workshops. They have published research papers in national and
              international journals and conferences. I would like to take this opportunity and appeal to all students
              to start their bright engineering career right after 12th standard by joining BE (Mechanical) course! Wish
              you all the very best!</p>
            <signature name="Prof. T. V. Gujrathi" designation="Head of the Department"></signature>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mechanical/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Signature from "@/components/Signature";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Signature,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped>
</style>
